module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "c"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("Remains of the Dead")]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_vm._v("Iain McKinnon")]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_vm._v("Published by Permuted Press at\nSmashwords.")]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_vm._v("Copyright 2011 Iain McKinnon.")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('span', {
    staticClass: "c1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.PermutedPress.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.PermutedPress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_vm._v("Cover art by Craig Patton.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c2"
  }, [_c('img', {
    staticClass: "calibre2",
    attrs: {
      "alt": "tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ_html_m7d6faf32.jpg",
      "id": "graphics1",
      "src": "tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ_html_m7d6faf32.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d47f7afe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue
// module id = 57
// module chunks = 0